import { EditBoardSettingsPanelProvider, useEditBoardSettingsPanelContext } from 'crm-pipeline-board-settings-lib/EditBoardSettingsPanel';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export const BoardSettingsPanelProvider = ({
  objectTypeId,
  children
}) => {
  let alreadyHasContext = true;
  try {
    useEditBoardSettingsPanelContext();
  } catch (e) {
    alreadyHasContext = false;
  }
  return alreadyHasContext ? /*#__PURE__*/_jsx(_Fragment, {
    children: children
  }) : /*#__PURE__*/_jsx(EditBoardSettingsPanelProvider, {
    objectTypeId: objectTypeId,
    children: children
  });
};